import script from "./InquiryDetailDetailsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailDetailsSection.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailDetailsSection.vue?vue&type=style&index=0&id=e58de9de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58de9de"]])

export default __exports__